import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/industries/utilities/UtilitiesClient.tsx");
